/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { DOCS_FILES } from '@sizeid/shared/constants/routes';
import Link from 'next/link';

interface FileLinkProps {
  id: string;
}

const FileLink: React.FC<FileLinkProps> = props => (
  <Link href={{ pathname: DOCS_FILES.route, query: { id: props.id } }}>
    <a>{props.children}</a>
  </Link>
);

export default FileLink;
